function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -0.145,
  y1: 1,
  x2: 3.216,
  y2: 2.774,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d9ecf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00edcb"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_111",
  "data-name": "Group 111"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_196",
  "data-name": "Path 196",
  d: "M155.049,146.366l-26.411,29.4-13.928-13.36a3.1,3.1,0,0,0-4.281,4.488l16.2,15.578a3.041,3.041,0,0,0,2.167.877h.1a3.1,3.1,0,0,0,2.167-1.032l28.577-31.776a3.1,3.1,0,0,0-.258-4.385A3,3,0,0,0,155.049,146.366Z",
  transform: "translate(-89.538 -118.871)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_197",
  "data-name": "Path 197",
  d: "M45.446,0A45.446,45.446,0,1,0,90.891,45.446,45.483,45.483,0,0,0,45.446,0Zm0,84.7A39.255,39.255,0,1,1,84.7,45.446,39.275,39.275,0,0,1,45.446,84.7Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_209",
  "data-name": "Path 209",
  d: "M155.049,146.366l-26.411,29.4-13.928-13.36a3.1,3.1,0,0,0-4.281,4.488l16.2,15.578a3.041,3.041,0,0,0,2.167.877h.1a3.1,3.1,0,0,0,2.167-1.032l28.577-31.776a3.1,3.1,0,0,0-.258-4.385A3,3,0,0,0,155.049,146.366Z",
  transform: "translate(-89.538 -118.871)",
  fill: "url(#linear-gradient)"
}));

function SvgCheckingMarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checking-mark-circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90.891,
    height: 90.891,
    viewBox: "0 0 90.891 90.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckingMarkCircle);
export default __webpack_public_path__ + "static/media/checking-mark-circle.3f88e767.svg";
export { ForwardRef as ReactComponent };